export default "__VITE_ASSET__ZzgyJVE5__"